import { Leaf } from "lucide-react";
import React from "react";
import { COMPANY_NAME, ImpactAssessmentMethodText } from "../../config/constants";
import { Card, CardContent } from "../ui/common/card";

interface ClimateImpactCardProps {
  measure?: number;
  unit?: string;
  /** Noun after "/kg" — "kg CO₂e /kg ingredient" vs "… /kg product". Defaults to "product". */
  basisLabel?: string;
}

/**
 * Shared "Climate Change Impact" card — used by the Product Summary page and
 * the Product/Ingredient details modals' Environmental Footprint tabs.
 * Padding is identical across all three contexts, so unlike `ProductInfoCard`
 * / `LifecycleStagesCard` this one needs no `compact` variant.
 */
const ClimateImpactCard: React.FC<ClimateImpactCardProps> = ({
  measure,
  unit,
  basisLabel = "product"
}) => {
  return (
    <Card className="tw-border-border tw-rounded-lg tw-bg-gradient-to-br tw-pt-0 tw-mt-0 tw-from-card tw-to-secondary/30 tw-overflow-hidden">
      <CardContent className="tw-p-2 tw-flex tw-flex-col tw-text-center tw-h-full">
        <div className="tw-w-full tw-border-b tw-border-primary/20 tw-pb-2.5 tw-mb-3.5">
          <p className="tw-text-sm tw-font-semibold tw-text-primary tw-py-1.5">
            Climate Change Impact
          </p>
        </div>
        <div className="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center">
          <Leaf className="tw-h-7 tw-w-7 tw-text-primary/30 tw-mb-2" />
          <p className="tw-text-5xl tw-font-display tw-font-bold tw-text-foreground tw-leading-none">
            {measure?.toFixed(2) || "0.00"}
          </p>
          <p className="tw-text-sm tw-text-muted-foreground tw-mt-1.5 tw-font-medium">
            {unit || "kgCO₂eq"} /kg {basisLabel}
          </p>
          <div className="tw-mt-2 tw-bg-secondary/50 tw-rounded-md tw-p-3.5 tw-text-[11px] tw-text-muted-foreground tw-leading-relaxed">
            {COMPANY_NAME} {ImpactAssessmentMethodText}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ClimateImpactCard;
